import { render, staticRenderFns } from "./FacebookMessengerSettingsCard.vue?vue&type=template&id=5b335294"
import script from "./FacebookMessengerSettingsCard.vue?vue&type=script&lang=ts"
export * from "./FacebookMessengerSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports